import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tracker } from '../../models/tracker';
import { TrackerService } from '../../services/tracker.service';
import * as trackerSides from '../../config/TrackerSide';
import { Gym } from '../../models/gym';
import { GymService } from '../../services/gym.service';
import * as TrackerStates from '../../config/TrackerStates';

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss']
})
export class TrackerComponent implements OnInit {

    public listOfTrackers: Array<Tracker>;
    public listOfSelectedTrackers: Array<Tracker>;
    public stateFilter = '';
    public editingTracker: Tracker;
    public ErrorMsg = '';
    public editMode: boolean;
    public sidesArray: Array<any>;
    public listOfGyms: Array<Gym>;
    public TrackerStates: any;

    @Input() selectedGymId: string;

    constructor(private route: ActivatedRoute, private trackerService: TrackerService, private gymService: GymService) { }

    ngOnInit() {
      this.editMode = false;
      this.TrackerStates = TrackerStates;
      this.editingTracker = new Tracker();
      this.listOfTrackers = [];
      this.listOfSelectedTrackers = [];
      this.gymService.getAllGyms().then((gyms) => {
        this.listOfGyms = gyms;
        this.trackerService.getAllTrackers().then((trackers) => {
          this.listOfTrackers = trackers;
          this.listOfSelectedTrackers = trackers;
        });
      });
      this.sidesArray = [];
      this.sidesArray.push({value: trackerSides.TRACKER_LEFT, name: 'Left'});
      this.sidesArray.push({value: trackerSides.TRACKER_RIGHT, name: 'Right'});
    }

    filterTrackersByState() {
      this.listOfSelectedTrackers = [];
      this.listOfTrackers.forEach(tracker => {
        if (tracker.state === this.stateFilter) {
          this.listOfSelectedTrackers.push(tracker);
        }
      });
    }

    addTracker() {
      if (this.editingTracker._id && this.editingTracker.side) {
        this.trackerService.addTracker(this.editingTracker)
          .subscribe(() => { this.ngOnInit(); });
      } else {
        this.ErrorMsg = 'Device ID, Side, Gym are required.';
      }
    }

    delTracker(id) {
      if (id) {
        this.trackerService.delTracker(id)
            .subscribe(() => { this.ngOnInit(); } );
      }
    }

    setTrackerToEdit(tracker) {
      this.editMode = true;
      this.editingTracker = tracker;
    }

    editTracker() {
      this.trackerService.editTracker(this.editingTracker).subscribe(() => this.ngOnInit());
      this.editMode = false;
    }

    quitEditingMode() {
      this.editMode = false;
      this.editingTracker = new Tracker();
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/tracker/tracker.component.ts